export class CustCard_1 {
    customerId: number;
    fl: string;
    autoClassificationId?: number;
    autoClassificationName?: string;
    age?: number;
    birthDay?: number;
    isVip?: boolean;
    debt?: number;
    sex?: number;
}

export class CustomerIn {
    customer_id: number;
}

export class CustomerStepVisitIn {
    customer_id: number;
    dateEvent: string; 
}
